<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/icr5tz/tc-custom/9780802189851.jpg?1718251154932" alt="This image is the cover for the book Rush of Blood"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rush of Blood
      </h1>
      <p class="bookDescription body article font2">
        <b>Perfect strangers. A perfect vacation. The perfect murder. . . . </b><b>“Hugely effective and entertaining [with] many twists and shocks” (<i>The</i><i>Times</i>, London).</b><br/>  <br/> Three British couples meet around the pool on their Florida holiday and become fast friends. But on Easter Sunday, the last day of their vacation, tragedy strikes: The fourteen-year-old daughter of an American vacationer goes missing, and her body is later found floating in the mangroves.<br/> When the shocked couples return home to the United Kingdom, they remain in contact, and over the course of three increasingly fraught dinner parties they come to know one another better. But they don’t always like what they find. Buried beneath these apparently normal exteriors are some unusual kinks and unpleasant vices. Then, a second girl goes missing, in Kent—not far from where the couples live. Could it be that one of these six has a secret far darker than anybody can imagine?<br/>  <br/> Ambitiously plotted and laced with dark humor, <i>Rush of Blood</i> is a “sizzling thriller” by the international bestselling author of the Tom Thorne Novels (<i>The Globe and Mail</i>, Toronto).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Billingham
      </h2>
      
      <p class="authorDescription body article"><B>Mark Billingham</B> has twice won the Theakstons Old Peculier Award for Best Crime Novel and also won the Sherlock Award for &#147;Best Detective Created by a British Author.&#8221; His books, which include the critically acclaimed Tom Thorne series, have been translated into twenty-five languages and have sold over four million copies. He lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atlantic Monthly Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12900820